/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '~/common/types/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type ChangeRequestCreateInput = {
  cascadeRelationIds?: Array<string> | null | undefined;
  context: Types.JsonObject;
  description: string;
  entityId?: string | null | undefined;
  evidenceId?: string | null | undefined;
  modelPropsInput: Types.JsonObject;
  recordMetadataId?: string | null | undefined;
  relationId?: string | null | undefined;
  tenantId: string;
};

export type CreateRelationChangeRequestMutationVariables = Exact<{
  input: Types.ChangeRequestCreateInput;
}>;


export type CreateRelationChangeRequestMutation = { cnutCreateChangeRequest: { __typename: 'ChangeRequestCreateOutput', id: string } };


export const CreateRelationChangeRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateRelationChangeRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeRequestCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cnutCreateChangeRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateRelationChangeRequestMutation, CreateRelationChangeRequestMutationVariables>;